import React from 'react';
import SummaryDetails from '../../../ssm-homepage/ssm-components/summary-details/summary-details';
import Benefit from '../benefit/benefit';

const TransitionInformation = (props) => {
  const { title, benefit1, benefit2, benefit3, customHeadingClass, customSubHeadingClass, customBenefitDescriptionClass } = props;
  return (
    <div className="transition-information padding-top-bottom-24">
      <SummaryDetails
        summaryTitle={title}
        customHeadingClass={customHeadingClass}
      />
      <div className="row">
        <Benefit
          benefit={benefit1}
          customSubHeadingClass={customSubHeadingClass}
          customDescriptionClass={customBenefitDescriptionClass}
        />
        <Benefit
          benefit={benefit2}
          customSubHeadingClass={customSubHeadingClass}
          customDescriptionClass={customBenefitDescriptionClass}
        />
        <Benefit
          benefit={benefit3}
          customSubHeadingClass={customSubHeadingClass}
          customDescriptionClass={customBenefitDescriptionClass}
        />
      </div>
    </div>
  );
};

export default TransitionInformation;
